import { Provider } from '@mindtickle/snowplow-client';

import type { ComponentEnhancer } from 'recompose';

import { useExtendedLogger } from '../Logger';

import { LOGGER_NAME } from './constants';
import { ISnowplowContext } from '@mindtickle/snowplow-client/lib/core/interfaces/tracker';

const withSnowplow = <P extends {}>({
  collectorUrl,
  namespace,
  globalContexts,
}: {
  collectorUrl: string;
  namespace: string;
  globalContexts?: ISnowplowContext[];
}) => {
  const enhancer = (Component: React.ComponentType<P>) => (props: P) => {
    const log = useExtendedLogger(LOGGER_NAME);

    log(
      'adding provider with %s as collector url <%s> and namespace <%s>',
      collectorUrl,
      namespace
    );

    return (
      <Provider collectorUrl={collectorUrl} namespace={namespace} globalContexts={globalContexts}>
        <Component {...props} />
      </Provider>
    );
  };
  return (enhancer as unknown) as ComponentEnhancer<P, P>;
};

export default withSnowplow;
